import { eSigningMethod } from '../../../types/signingAppointment/eSigningMethod';

// Many labels require the "Attorney Partner" or "Notary", and this is dependent upon the signingMethod
export const attorneyOrNotary = (signingMethod?: string): string => {
  if (signingMethod === eSigningMethod.attorney) {
    return 'Attorney Partner';
  }
  return 'Notary';
};
